<template>
  <ak-cards-item class="app-card-wrapper">
    <ak-card class="app-card">
      <ak-app-published-status :app="app" />

      <div class="app-card-links">
        <ak-tooltip theme="dark" placement="left" :has-arrow="false">
          <template #trigger>
            <ak-button
              v-if="appType === 'pages'"
              tag="a"
              :href="makePreviewUrl(app)"
              target="_blank"
              size="small"
              color="semi-transparent"
              circle
            >
              <ak-icon type="open" />
            </ak-button>
          </template>
          Open Link
        </ak-tooltip>
        <ak-attached-action position="bottom">
          <ak-tooltip
            v-if="app.publishedStatus && !app.hidden"
            theme="dark"
            placement="left"
            :has-arrow="false"
          >
            <template #trigger>
              <ak-button
                color="semi-transparent"
                size="small"
                circle
                class="mb-tiny"
                @click.stop.prevent="copyShortUrl(app)"
              >
                <ak-icon type="link" />
              </ak-button>
            </template>
            Copy Link
          </ak-tooltip>
          <ak-tooltip
            v-if="app.publishedStatus && !app.hidden"
            theme="dark"
            placement="left"
            :has-arrow="false"
          >
            <template #trigger>
              <ak-button
                color="semi-transparent"
                size="small"
                circle
                @click.stop.prevent="copyEmbedCode(app)"
              >
                <ak-icon type="code" />
              </ak-button>
            </template>
            Copy Embed Code
          </ak-tooltip>
        </ak-attached-action>
        <!-- <ak-layout-builder
          static-icon
          no-shadow
          class="app-list-links"
          :show-drag="false"
        >
          <template #actions>
            <ak-tooltip theme="light" placement="bottom">
              <template #trigger>
                <ak-button
                  v-if="appType === 'pages'"
                  tag="a"
                  :href="makePreviewUrl(app)"
                  target="_blank"
                  size="small"
                  color="grey-dark"
                  circle
                >
                  <ak-icon type="open" />
                </ak-button>
              </template>
              Open Link
            </ak-tooltip>
          </template>
          <template #actionsExpanded>
            <ak-tooltip
              v-if="app.publishedStatus && !app.hidden"
              theme="light"
              placement="bottom"
              class="mr-tiny"
            >
              <template #trigger>
                <ak-button
                  size="small"
                  color="grey-dark"
                  circle
                  @click.stop.prevent="copyShortUrl(app)"
                >
                  <ak-icon type="link" />
                </ak-button>
              </template>
              Copy Link
            </ak-tooltip>
            <ak-tooltip
              v-if="app.publishedStatus && !app.hidden"
              theme="light"
              placement="bottom"
            >
              <template #trigger>
                <ak-button
                  size="small"
                  color="grey-dark"
                  circle
                  @click.stop.prevent="copyEmbedCode(app)"
                >
                  <ak-icon type="code" />
                </ak-button>
              </template>
              Copy Embed Code
            </ak-tooltip>
          </template>
        </ak-layout-builder> -->
      </div>

      <ak-card-image
        class="h-225 app-card__preview"
        :hover-scroll="true"
        :tag="'router-link'"
        :to="appLink"
        :src="makePreviewImage(app, true)"
      />

      <ak-card-body class="flex__item flex flex--column py-small">
        <div class="flex__item">
          <h4 class="color-grey color-link-hover text-bold mb-0 text-breakout">
            <router-link :to="appLink">
              {{ app.title }}
            </router-link>
          </h4>
          <p class="text-small mb-tiny">{{ app.campaignLabel }}</p>
        </div>
        <div>
          <div class="mb-tiny text-small">
            <div v-if="app.startDate">
              Starts:
              <strong>{{ formatDate(app.startDate, 'DD/MM/YYYY') }}</strong>
            </div>
            <div v-if="app.endDate">
              Ends:
              <strong>{{ formatDate(app.endDate, 'DD/MM/YYYY') }}</strong>
            </div>
          </div>

          <div class="flex text-small">
            <em class="">Edited {{ fromNow(app.updatedOn) }}</em>

            <router-link
              class="ml-auto color-text text-bold inline-block color-link-hover text-link"
              :class="demoClass"
              :to="{ name: 'singleAppLeads', params: { appId: app._id } }"
            >
              <span v-if="!app.leadCount || app.leadCount > 1"
                >{{ app.leadCount }} {{ leadsBrandingPlural }}</span
              >
              <span v-else>{{ app.leadCount }} {{ leadsBrandingSingle }}</span>
            </router-link>
          </div>
        </div>
      </ak-card-body>

      <ak-card-footer class="flex flex--center py-tiny px-0">
        <router-link class="color-primary text-bold ml" :to="appLink"
          >Edit</router-link
        >
        <ak-apps-list-actions
          class="ml-auto mr-tiny"
          :app="app"
          :app-link="appLink"
          :app-settings="appSettings"
          :app-type="appType"
          :delete-app="deleteApp"
          :active-account="activeAccount"
          :active-agency="activeAgency"
          :clone-app="cloneApp"
          :create-url="createUrl"
          :url-builder-enabled="urlBuilderEnabled"
          :current-view="currentView"
        />
      </ak-card-footer>
    </ak-card>
  </ak-cards-item>
</template>

<script>
import CardImage from '@akerolabs/akero-vue/src/components/cards/CardImage.vue'
import CardBody from '@akerolabs/akero-vue/src/components/cards/CardBody.vue'
import CardFooter from '@akerolabs/akero-vue/src/components/cards/CardFooter.vue'
import CardsItem from '@akerolabs/akero-vue/src/components/cards/CardsItem.vue'
import Card from '@akerolabs/akero-vue/src/components/cards/Card.vue'
import Tooltip from '@akerolabs/akero-vue/src/components/tooltip/Tooltip.vue'
import Button from '@akerolabs/akero-vue/src/components/button/Button.vue'
import Icon from '@akerolabs/akero-vue/src/components/icon/Icon.vue'
import AttachedAction from '@akerolabs/akero-vue/src/components/attachedAction/AttachedAction.vue'
import AppsListActions from './AppsListActions.vue'
import AppPublishedStatus from '../AppPublishedStatus.vue'
import appsListRowMixin from './appsListRowMixin.js'

import { defineComponent } from 'vue'

export default defineComponent({
  /**
   * @type {String}
   * @description This is the name of the component this will also
   * be the tag name of the component to use in templates
   * @example
   * <ak-apps-list-card-item />
   */
  name: 'AkAppsListCardItem',

  /**
   * @type {Object}
   * @description A collection of components that this component
   * is dependant on.
   */
  components: {
    [CardImage.name]: CardImage,
    [CardBody.name]: CardBody,
    [CardsItem.name]: CardsItem,
    [CardFooter.name]: CardFooter,
    [Card.name]: Card,
    [Tooltip.name]: Tooltip,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [AppsListActions.name]: AppsListActions,
    [AttachedAction.name]: AttachedAction,
    [AppPublishedStatus.name]: AppPublishedStatus,
  },

  /**
   * @type {Object}
   * @description A collection of properties that may be passed into
   * the component these will be bound to the component instance and
   * may be access in the template and component methods.
   */
  props: {
    /**
     * @type {Object}
     * @description The active account (drilled in or users)
     */
    activeAccount: {
      default: () => ({}),
      type: Object,
    },

    /**
     * @type {Object}
     * @description The active agency (drilled in or users)
     */
    activeAgency: {
      default: () => ({}),
      type: Object,
    },

    app: {
      default: () => ({}),
      type: Object,
    },

    appType: {
      default: 'pages',
      type: String,
    },

    domains: {
      default: '',
      type: String,
    },

    deleteApp: {
      default: () => {},
      type: Function,
    },

    cloneApp: {
      default: () => {},
      type: Function,
    },

    createUrl: {
      default: () => {},
      type: Function,
    },

    urlBuilderEnabled: {
      default: false,
      type: Boolean,
    },
    currentView: {
      type: String,
      default: undefined,
    },
  },

  /**
   * @param {Object} props - The properties of the component
   * @param {Object} options - The setup options
   * @param {Function} options.emit - The emit method for triggering events
   * @description Sets up the component and returns an object containing all of the
   * attributes for the component to use.
   */
  setup(props, { emit }) {
    const mixin = appsListRowMixin({ props, emit })
    return {
      ...mixin,
    }
  },
})
</script>
